import { useContext } from "react";
import { TabsContext } from "./TabsContext";

export function useTabsContext<T extends string = string>() {
  const ctx = useContext(TabsContext);

  if (!ctx) {
    throw new Error("Tabs components must be used inside <TabsContainer />");
  }

  const { activeValue, setActiveValue, idPrefix } = ctx;

  return {
    activeValue: activeValue as T,
    setActiveValue: setActiveValue as (val: T) => void,
    idPrefix,
  };
}
